import {useFormikContext} from 'formik';
import {FormItem, Input, Select} from 'formik-antd';
import {useCountries} from 'hooks/useCountries';
import React, {useState} from 'react';
import {PayByLinkFormValues} from './common';

type Props = {
  name: string;
};

const {Option} = Select;

export const ContactDetailsFields: React.FC<Props> = ({name}) => {
  const {isoCountries, getCountryName, getIsoCountry} = useCountries();
  const [countryCode, setCountryCode] = useState();
  const selectedCountry = getIsoCountry(countryCode);
  const {setFieldValue} = useFormikContext<PayByLinkFormValues>();
  return (
    <>
      <FormItem name={`${name}.address.country`}>
        <Select
          name={`${name}.address.country`}
          placeholder="Country"
          optionFilterProp="children"
          showSearch
          onChange={(value) => {
            setFieldValue(`${name}.address.country`, value);
            setFieldValue(`${name}.address.state`, '');
            setFieldValue(`${name}.address.zip`, '');
            setCountryCode(value);
          }}>
          {isoCountries.map((country) => (
            <Option value={country.code} key={country.code}>
              {getCountryName(country.code)}
            </Option>
          ))}
        </Select>
      </FormItem>
      <FormItem name={`${name}.address.state`}>
        <Select
          name={`${name}.address.state`}
          optionFilterProp="children"
          showSearch
          placeholder={'State / Province / Region'}>
          {selectedCountry &&
            Object.keys(selectedCountry?.divisions)
              .sort((code1, code2) =>
                selectedCountry?.divisions[code1].localeCompare(selectedCountry?.divisions[code2])
              )
              .map((code) => (
                <Option
                  key={selectedCountry?.divisions[code]}
                  value={selectedCountry?.divisions[code]}>
                  {selectedCountry?.divisions[code]}
                </Option>
              ))}
        </Select>
      </FormItem>
      <FormItem name={`${name}.address.city`}>
        <Input name={`${name}.address.city`} placeholder={'City'} />
      </FormItem>
      <FormItem name={`${name}.address.zip`}>
        <Input name={`${name}.address.zip`} placeholder={'Zip / Postal code'} />
      </FormItem>
      <FormItem name={`${name}.address.line1`}>
        <Input name={`${name}.address.line1`} placeholder={'Street, 123'} />
      </FormItem>
    </>
  );
};
